import React, { useId } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

type Placement = 'top' | 'bottom' | 'left' | 'right';

interface TipProps {
  text: string;
  placement?: Placement;
  children: React.ReactElement;
}

/**
 * Lightweight hover tooltip — wrap any element (icon button, badge, link)
 * with <Tip text="...">. Shows on mouseover/focus, hides on leave/blur.
 * Backed by `react-tooltip` so positioning, collision detection, and animation
 * are handled by the library.
 */
const Tip: React.FC<TipProps> = ({ text, placement = 'top', children }) => {
  const reactId = useId();
  // useId returns ':r0:' style strings — strip colons since they're invalid in CSS selectors/HTML ids
  const tipId = `tip-${reactId.replace(/:/g, '')}`;

  // Clone the child element to inject the data-tooltip-* attrs that react-tooltip looks for.
  const trigger = React.cloneElement(children as React.ReactElement<any>, {
    'data-tooltip-id': tipId,
    'data-tooltip-content': text,
    'data-tooltip-place': placement,
  });

  return (
    <>
      {trigger}
      <ReactTooltip
        id={tipId}
        className="app-tip"
        style={{ zIndex: 10001 }}
      />
    </>
  );
};

export default Tip;
